import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SkipDayPopupComponent } from '../../My-DWM/skip-day-popup/skip-day-popup.component';
import { DateAdapter } from '@angular/material/core';
import { Inject } from '@angular/core';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';
@Component({
  selector: 'app-dwmaudittrail',
  templateUrl: './dwmaudittrail.component.html',
  styleUrls: ['./dwmaudittrail.component.scss']
})
export class DwmaudittrailComponent implements OnInit {
  displayedColumns: string[] = ['sNo', 'columnName', 'changeType', 'oldValue', 'newValue', 'modifiedBy', 'modifiedDate'];

  totalItems = 0;
  pageSize = 5;
  currentPage = 0;
  buttonColorName: any;
  selectedYear: any;
  getIncrementFyYearList: any = [];
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  fromYear: any;
  toYear: any;
  subModuleButtonColor: any;
  selectChangeType: any = 'All';
  pmsYears: any = [];
  selectedYearForDWM: any = null;
  isCurrentYearSelected: boolean = false;
  arrAllMonths: any[] = [];
  selectedMonth: string = '';
  dwmPlusFormDate: Date = new Date();
  selectedEmployeeId: any;
  auditData: any[] = [];
  loggedInUserId: any;
  loggedInUserRole: any;
  loggedInUserName: any;
  loggedInUserEmpCode: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any;
  auditHeaders: string[] = ['Field Name', 'Old Value', 'Created At', 'New Value', 'Modified By', 'Modified Date'];
  constructor(
    private httpService: HttpService,
    private config: Config,
    private datePipe: DatePipe,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private dateAdapter: DateAdapter<Date>,
    public sharedService: SharedService,
    public dwmGenericServiceService: DwmGenericServiceService,
    public dialogRef: MatDialogRef<DwmaudittrailComponent>
  ) {
    this.dateAdapter.setLocale('en-GB');
  }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    console.log('User Id is....', this.loggedInUserId);
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');

    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    console.log('Admin is....', this.loggedInUserRoles);
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;

    this.getpmsyearlist();
    this.getAuditData(this.data.taskId);
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  defaultCallFunctionsList() {
    this.getAuditData(this.data.taskId);
  }

  selectYearSetup(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    this.defaultCallFunctionsList();
  }

  onMonthChange(event: any) {
    // console.log('Selected month:', this.selectedMonth);
  }

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    this.isCurrentYearSelected = year === currentFiscalYear;
  }

  // getAuditData(taskId: number) {
  //   this.httpService.callGetService(`${this.config.getDWMAuditTrail}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
  //     // Filter audit data to only include matching dwmTransactionId
  //     this.auditData = (res.data || []).filter((audit: any) => +audit.dwmTransactionId === +taskId);
  //     // console.log('Filtered Audit Data:', this.auditData);
  //   });
  // }

  getAuditData(taskId?: number) {
    this.httpService.callGetService(`${this.config.getDWMAuditTrail}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      let data = res.data || [];

      //  task specific (ALL ROLES, ALL USERS)
      if (taskId) {
        data = data.filter((audit: any) => +audit.dwmTransactionId === +taskId);
      }

      //
      if (!taskId) {
        const isAdmin = this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin';

        //  Normal user → only own changes
        if (!isAdmin) {
          data = data.filter((audit: any) => +audit.lastModifiedBy === +this.loggedInUserId);
        }

        //  HR / Super Admin → NO FILTER (see everything)
      }

      console.log('Final Audit Data:', data);
      this.auditData = data;
    });
  }

  onDateChange() {}

  onChangeSelectedEmployee() {}

  onClickClearFilter() {}

  // ---------------------------- Downloads --------------------------
  downloadPDF() {}

  downloadExcel() {}
}
